/* global querystring */
define("querystring", [], function (
) {
    return querystring;
});